import React from 'react';
import { IconProps } from '../types/Icon';

export default function LoginIcon({ height = 18, width = 18, colour = '#fff' }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.11719 12.9236C5.11719 13.1724 5.11719 13.2969 5.12829 13.405C5.22042 14.303 5.86987 15.0448 6.74781 15.2548C6.85356 15.2801 6.97692 15.2966 7.22355 15.3294L11.8928 15.952C13.222 16.1292 13.8865 16.2178 14.4023 16.0127C14.8552 15.8327 15.2324 15.5024 15.4707 15.0774C15.7422 14.5932 15.7422 13.9227 15.7422 12.5818V6.18201C15.7422 4.84111 15.7422 4.17066 15.4707 3.68649C15.2324 3.26141 14.8552 2.93116 14.4023 2.7511C13.8865 2.54601 13.222 2.63462 11.8928 2.81184L7.22355 3.43441C6.97689 3.4673 6.85356 3.48374 6.74781 3.50904C5.86987 3.71905 5.22042 4.46083 5.12828 5.35883C5.11719 5.467 5.11719 5.59142 5.11719 5.84026M9.36719 6.54859L12.2005 9.38193M12.2005 9.38193L9.36719 12.2153M12.2005 9.38193H2.99219"
                stroke={colour}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
